// MANTO CART DRAWER - Sprint 3 FIX
// Arquivo: assets/manto-cart-drawer.js
// Versão: MANTO-S3 + FIX-QTY + PDP-AJAX


(() => {
  "use strict";

  const SELECTORS = {
    drawer: "#CartDrawer",
    content: "#CartDrawerContent",
    items: "#CartDrawerItems",
    empty: "#CartDrawerEmpty",
    subtotal: "#CartDrawerSubtotal",
    progress: "#CartDrawerProgress",
    progressAmount: "#CartDrawerProgressAmount",
    progressFill: "#CartDrawerProgressFill",
    progressStep1: "#CartDrawerProgressStep1",
    progressStep2: "#CartDrawerProgressStep2",
    openers: "[data-manto-cart-toggle]",
    closeButtons: "[data-cart-close]",
    overlay: ".cart-drawer__overlay"
  };

  function qs(sel, root = document) {
    return root.querySelector(sel);
  }

  function qsa(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  function formatMoney(cents) {
    const v = Number(cents || 0) / 100;
    return v.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  }

  async function fetchJSON(url, options) {
    const res = await fetch(url, Object.assign({
      headers: { "Accept": "application/json" },
      cache: "no-store"
    }, options || {}));
    if (!res.ok) throw new Error("Erro ao carregar " + url);
    return res.json();
  }

  async function getCart() {
    return fetchJSON("/cart.js");
  }

  async function changeLineItem(key, quantity) {
    const payload = { id: key, quantity: quantity };
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error("Erro ao atualizar item");
    // Não confiamos no shape do retorno → refresh separado
    return res;
  }

  class MantoCartDrawerController {
    constructor() {
      this.drawer = qs(SELECTORS.drawer);
      if (!this.drawer) return;

      this.content = qs(SELECTORS.content, this.drawer);
      this.itemsList = qs(SELECTORS.items, this.drawer);
      this.emptyState = qs(SELECTORS.empty, this.drawer);
      this.subtotalEl = qs(SELECTORS.subtotal, this.drawer);
      this.progressBar = qs(SELECTORS.progress, this.drawer);
      this.progressAmountEl = qs(SELECTORS.progressAmount, this.drawer);
      this.progressFillEl = qs(SELECTORS.progressFill, this.drawer);
      this.progressStep1 = qs(SELECTORS.progressStep1, this.drawer);
      this.progressStep2 = qs(SELECTORS.progressStep2, this.drawer);

      this.isOpen = false;
      this.isRefreshing = false;

      this._bindEvents();
      this._syncCountFromDOM();
    }

    _bindEvents() {
      // Abrir via header / triggers
      document.addEventListener("click", (event) => {
        const opener = event.target.closest(SELECTORS.openers);
        if (!opener) return;
        event.preventDefault();
        this.open({ refresh: true });
      });

      // Listener complementar: se o tema disparar "product:added", abrimos/atualizamos o drawer
      document.addEventListener("product:added", () => {
        this.refresh({ openOnUpdate: true }).catch(() => {});
      });

      // Delegação dentro do drawer: overlay, fechar, qty, remover
      this.drawer.addEventListener("click", (event) => {
        // Overlay e botões de fechar
        if (
          event.target.closest(SELECTORS.overlay) ||
          event.target.closest(SELECTORS.closeButtons)
        ) {
          event.preventDefault();
          this.close();
          return;
        }

        // Quantidade +/-
        const qtyBtn = event.target.closest("[data-manto-cart-qty]");
        if (qtyBtn) {
          event.preventDefault();
          const direction = qtyBtn.getAttribute("data-manto-cart-qty");
          const key = qtyBtn.getAttribute("data-manto-cart-id");
          if (!key) return;

          const itemNode = qtyBtn.closest("[data-manto-cart-item]");
          const currentQtyEl = itemNode && itemNode.querySelector("[data-manto-cart-qty-value]");
          const currentQty = currentQtyEl ? parseInt(currentQtyEl.textContent.trim(), 10) || 1 : 1;
          const newQty = direction === "plus" ? currentQty + 1 : Math.max(0, currentQty - 1);

          this._setQuantity(key, newQty);
          return;
        }

        // Remover item
        const removeBtn = event.target.closest("[data-manto-cart-remove]");
        if (removeBtn) {
          event.preventDefault();
          const key = removeBtn.getAttribute("data-manto-cart-id");
          if (!key) return;
          this._setQuantity(key, 0);
          return;
        }
      });

      // ESC fecha drawer
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && this.isOpen) {
          this.close();
        }
      });

      // Events de compatibilidade

      // Intercepta submits de formulários de add-to-cart para garantir AJAX + Drawer
      document.addEventListener(
        "submit",
        (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          const action = (form.getAttribute("action") || "").toLowerCase();
          if (!/\/cart\/add(\.js)?/.test(action)) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation && event.stopImmediatePropagation();

          try {
            const formData = new FormData(form);

            // Remove sections_url e outros parâmetros pesados, vamos só adicionar
            if (formData.has("sections_url")) {
              formData.delete("sections_url");
            }

            this._setLoading(true);

            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                Accept: "application/json",
              },
              body: formData,
            })
              .then((res) => {
                if (!res.ok) throw new Error("Erro ao adicionar manto");
                return res.json();
              })
              .then(() => {
                return this.refresh({ openOnUpdate: true });
              })
              .catch((err) => {
                console.error("[MantoCartDrawer] erro no add-to-cart via submit", err);
              })
              .finally(() => {
                this._setLoading(false);
              });
          } catch (err) {
            console.error("[MantoCartDrawer] erro geral no submit handler", err);
          }
        },
        true // capture = pega antes de outros listeners
      );

      document.addEventListener("cart:open", () => {
        this.refresh({ openOnUpdate: true }).catch(() => {});
      });
      document.addEventListener("cart:refresh", () => {
        this.refresh({ openOnUpdate: false }).catch(() => {});
      });
    }

    async _setQuantity(key, quantity) {
      if (this.isRefreshing) return;
      this.isRefreshing = true;
      this._setLoading(true);
      this._setItemLoading(key, true);
      try {
        await changeLineItem(key, quantity);
        // Após atualizar a linha, buscamos o carrinho completo e re-renderizamos
        const cart = await getCart();
        await this._render(cart);
      } catch (e) {
        console.error("[MantoCartDrawer] erro ao atualizar quantidade", e);
      } finally {
        this._setItemLoading(key, false);
        this.isRefreshing = false;
        this._setLoading(false);
      }
    }

    _setLoading(loading) {
      if (!this.content) return;
      this.content.classList.toggle("is-loading", Boolean(loading));
    }


    _setItemLoading(key, loading) {
      if (!this.itemsContainer || !key) return;
      try {
        const selector = '[data-manto-cart-id="' + key + '"]';
        const itemEl = this.itemsContainer.querySelector(selector);
        if (!itemEl) return;
        itemEl.classList.toggle("is-loading", Boolean(loading));
      } catch (e) {
        console.warn("[MantoCartDrawer] _setItemLoading falhou para key:", key, e);
      }
    }

    async refresh(options) {
      if (this.isRefreshing) return;
      this.isRefreshing = true;
      this._setLoading(true);
      const opts = options || {};
      try {
        const cart = await getCart();
        await this._render(cart);
        if (opts.openOnUpdate) {
          this.open({ refresh: false });
        }
      } catch (e) {
        console.error("[MantoCartDrawer] erro ao atualizar carrinho", e);
      } finally {
        this.isRefreshing = false;
        this._setLoading(false);
      }
    }

    async open(options) {
      const opts = options || {};
      if (opts.refresh !== false) {
        await this.refresh({ openOnUpdate: false });
      }
      if (!this.drawer) return;
      // ✅ Abre com transição suave (2 frames para o CSS animar)
      this.drawer.hidden = false;
      this.drawer.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("cart-drawer-open");
      this.isOpen = true;

      // Força render antes de aplicar a classe de animação
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!this.drawer) return;
          this.drawer.classList.add("is-open");
        });
      });
    
      // ✅ Micro-interação: animação dos checks ativa assim que abre o drawer
      if (this.progressStep1) this.progressStep1.classList.add("is-active");
      if (this.progressStep2) this.progressStep2.classList.add("is-active");
}

    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove("is-open");
      this.drawer.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("cart-drawer-open");
      this.isOpen = false;

      // ✅ Fecha suave (esconde só após terminar a transição)
      window.setTimeout(() => {
        if (!this.drawer) return;
        // Se reabriu durante o timeout, não esconda
        if (this.drawer.classList.contains("is-open")) return;
        this.drawer.hidden = true;
      }, 340);
    }

    async _render(cart) {
      try {
        if (!this.drawer || !this.itemsList || !this.subtotalEl) return;
        if (!cart || !Array.isArray(cart.items)) return;

        const items = cart.items;
        const hasItems = items.length > 0;

        if (!hasItems) {
          this.itemsList.innerHTML = "";
          if (this.emptyState) {
            this.emptyState.hidden = false;
          }
        } else {
          if (this.emptyState) {
            this.emptyState.hidden = true;
          }
          const html = items.map((item) => this._renderItem(item)).join("");
          this.itemsList.innerHTML = html;
        }

        this.subtotalEl.textContent = formatMoney(cart.total_price || 0);

        // Promo Pague 2 Leve 3
        this._updatePromoBar(cart);

        // Badge global
        this._updateHeaderCount(cart.item_count || 0);

        this.drawer.setAttribute("data-item-count", String(cart.item_count || 0));
      } catch (e) {
        console.error("[MantoCartDrawer] erro no render()", e);
      }
    }

    _renderItem(item) {
      const key = item.key || item.id || item.variant_id || "";
      const title = item.product_title || item.title || "";
      const variant = (item.variant_title && item.variant_title !== "Default Title") ? item.variant_title : "";
      const quantity = item.quantity || 1;
      const linePrice = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
      const unitPrice = item.final_price != null ? item.final_price : (item.price || 0);

      let propertiesText = "";
      if (item.properties) {
        const parts = [];
        for (const propName in item.properties) {
          if (!Object.prototype.hasOwnProperty.call(item.properties, propName)) continue;
          const val = item.properties[propName];
          if (!val) continue;
          if (propName === "_bundle_hash" || propName === "_bundle_label") continue;
          parts.push(propName + ": " + val);
        }
        if (variant) parts.unshift(variant);
        propertiesText = parts.join(" · ");
      } else if (variant) {
        propertiesText = variant;
      }

      const hasBundleDiscount =
        (item.line_price === 0 && item.original_line_price > 0) ||
        (item.total_discount && item.total_discount >= item.line_price && item.line_price > 0);

      const showPague2Leve3 = Boolean(hasBundleDiscount);

      let imageHTML = "";
      if (item.image) {
        const escapedAlt = (title || "").replace(/"/g, "&quot;");
        imageHTML = `
          <div class="cart-drawer__item-media">
            <img
              src="${item.image}"
              alt="${escapedAlt}"
              loading="lazy"
              width="80"
              height="80"
              class="cart-drawer__item-image"
            />
          </div>`;
      }

      return `
        <li class="cart-drawer__item" data-manto-cart-item data-manto-cart-id="${key}">
          <div class="cart-drawer__item-main">
            ${imageHTML}
            <div class="cart-drawer__item-info">
              <div class="cart-drawer__item-header">
                <div class="cart-drawer__item-title-wrap">
                  <span class="cart-drawer__item-title" title="${title.replace(/"/g, "&quot;")}">
                    ${title}
                  </span>
                  ${propertiesText ? `<span class="cart-drawer__item-meta">${propertiesText}</span>` : ""}
                  ${showPague2Leve3 ? `<span class="cart-drawer__promo-tag">Pague 2 Leve 3</span>` : ""}
                </div>
                
              </div>

              
              <div class="cart-drawer__item-footer">
                <div class="cart-drawer__item-actions">
                  <div class="cart-drawer__qty" data-manto-cart-qty-wrap>
                    <button
                      type="button"
                      class="cart-drawer__qty-btn"
                      data-manto-cart-qty="minus"
                      data-manto-cart-id="${key}"
                      aria-label="Diminuir quantidade"
                    >−</button>
                    <span class="cart-drawer__qty-value" data-manto-cart-qty-value>
                      ${quantity}
                    </span>
                    <button
                      type="button"
                      class="cart-drawer__qty-btn"
                      data-manto-cart-qty="plus"
                      data-manto-cart-id="${key}"
                      aria-label="Aumentar quantidade"
                    >+</button>
                  </div>

                  <button
                    type="button"
                    class="cart-drawer__remove"
                    data-manto-cart-remove
                    data-manto-cart-id="${key}"
                    aria-label="Remover este item"
                  >
                    <svg class="cart-drawer__remove-icon" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M9 3h6a1 1 0 0 1 1 1v2h4v2h-1v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8H3V6h4V4a1 1 0 0 1 1-1zm1 3h4V5h-4v1zm-2 3v9h2V9H8zm4 0v9h2V9h-2zm4 0v9h2V9h-2z"/>
                    </svg>
                  </button>
                </div>

                <div class="cart-drawer__item-price-block cart-drawer__item-price-block--bottom">
                  <span class="cart-drawer__item-price">
                    ${formatMoney(linePrice)}
                  </span>
                  ${unitPrice && unitPrice !== linePrice ? `
                    <span class="cart-drawer__item-unit">
                      ${formatMoney(unitPrice)} cada
                    </span>
                  ` : ""}
                </div>

              </div>
            </div>
          </div>
        </li>
      `;
    }


    
    _updatePromoBar(cart) {
      if (!this.progressBar || !this.progressAmountEl || !this.progressFillEl) return;

      const totalQty = cart && typeof cart.item_count === "number" ? cart.item_count : 0;
      const step1Qty = 3; // 2 pagos + 1 de brinde
      const step2Qty = 6; // 4 pagos + 2 de brinde

      // Reset completo quando não há itens
      if (totalQty <= 0) {
        this.progressBar.hidden = true;
        this.progressBar.classList.remove("cart-drawer__progress--complete");
        this.progressFillEl.style.width = "0%";

      // ✅ Estado correto dos checks:
      // - Animação (lines) sempre ativa quando o drawer existe
      // - Verde (is-done) SOMENTE quando o marco foi atingido AGORA
      if (this.progressStep1) {
        this.progressStep1.classList.add("is-active");
        this.progressStep1.classList.toggle("is-done", totalQty >= step1Qty);
      }
      if (this.progressStep2) {
        this.progressStep2.classList.add("is-active");
        this.progressStep2.classList.toggle("is-done", totalQty >= step2Qty);
      }
        this.progressAmountEl.innerHTML = "";
        if (this.progressStep1) this.progressStep1.classList.remove("is-active");
        if (this.progressStep2) this.progressStep2.classList.remove("is-active");
        return;
      }

      this.progressBar.hidden = false;

      const mantosGratis = Math.floor(totalQty / 3);

      let html = "";
      let percent = 0;

      if (mantosGratis <= 0) {
        // Rumo ao primeiro manto de brinde
        const falta = Math.max(step1Qty - totalQty, 0);

        if (falta === 1) {
          html = "Falta só <strong>um</strong> pra completar o time e levar o <strong>brinde</strong>! ⚽";
        } else {
          html = "Faltam <strong>" + falta + "</strong> mantos pra liberar seu primeiro <strong>brinde</strong>! ⚽";
        }

        percent = Math.min(totalQty / step1Qty, 1) * 50; // 0% até 50%
        this.progressBar.classList.remove("cart-drawer__progress--complete");
      } else if (mantosGratis === 1 && totalQty < step2Qty) {
        // Já tem 1 brinde, caminhando para 2 brindes
        const falta = Math.max(step2Qty - totalQty, 0);

        if (falta === 3) {
          html = "Primeiro gol tá feito! Faltam <strong>3</strong> pro hat-trick de <strong>brindes</strong>. ⚽";
        } else if (falta === 2) {
          html = "O primeiro tá na rede! Garanta mais <strong>2</strong> e crava o segundo <strong>brinde</strong>. ⚽";
        } else if (falta === 1) {
          html = "Tá na cara do gol! Só mais <strong>um</strong> manto e o segundo <strong>brinde</strong> é seu. ⚽";
        } else {
          html = "O primeiro tá na rede! Garanta mais <strong>" + falta + "</strong> e crava o segundo <strong>brinde</strong>. ⚽";
        }

        const extra = totalQty - step1Qty;
        percent = 50 + Math.min(extra / (step2Qty - step1Qty), 1) * 50; // 50% até 100%
        this.progressBar.classList.remove("cart-drawer__progress--complete");
      } else {
        // Segundo patamar completo ou acima: mantos de brinde garantidos
        html = "Goleada de <strong>brindes</strong>! Mantos garantidos. Só falta o apito final: <strong>conclua</strong> o pedido. 🏆";
        percent = 100;
        this.progressBar.classList.add("cart-drawer__progress--complete");
      }

      
      // ✅ Aplica níveis: 1º check verde só ao bater 3, 2º check verde só ao bater 6
      if (totalQty >= step2Qty) {
        this.progressBar.classList.add("cart-drawer__progress--level2");
      } else if (totalQty >= step1Qty) {
        this.progressBar.classList.add("cart-drawer__progress--level1");
      }
this.progressAmountEl.innerHTML = html;
      this.progressFillEl.style.width = percent.toFixed(0) + "%";

      if (this.progressStep1) {
        this.progressStep1.classList.toggle("is-active", totalQty >= step1Qty);
      }
      if (this.progressStep2) {
        this.progressStep2.classList.toggle("is-active", totalQty >= step2Qty);
      }
    }
_updateHeaderCount(count) {
      const safe = Number.isFinite(count) ? count : 0;
      const nodes = qsa("[data-cart-count]");

      nodes.forEach((el) => {
        // Se existir um filho dedicado ao valor, usamos ele
        const valueNode = el.querySelector("[data-cart-count-value]");
        if (valueNode) {
          valueNode.textContent = String(safe);
        } else if (el.children.length === 0) {
          // Só sobrescreve texto se não houver filhos (evita apagar SVGs)
          el.textContent = String(safe);
        }

        const label =
          safe <= 0
            ? "Nenhum item na sacola"
            : safe === 1
              ? "1 item na sacola"
              : safe + " itens na sacola";

        el.setAttribute("aria-label", label);
      });
    }

    _syncCountFromDOM() {
      const raw = this.drawer.getAttribute("data-item-count");
      const count = parseInt(raw || "0", 10);
      if (Number.isFinite(count)) {
        this._updateHeaderCount(count);
      }
    }
  }

  function getCartFlags(url) {
    if (!url) return { any: false, add: false };
    const u = String(url);
    const any = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u);
    const add = /\/cart\/add(\.js)?(\?|$)/.test(u);
    return { any, add };
  }

  function hookCartNetwork(controller) {
    if (!controller) return;

    // Wrap fetch
    if (window.fetch && !window.fetch.__mantoCartWrapped) {
      const _fetch = window.fetch;
      const wrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        const input = args[0];
        const url = (typeof input === "string") ? input : (input && input.url) ? input.url : "";
        const flags = getCartFlags(url);

        return _fetch.apply(this, args).then(function(res) {
          if (flags.any && res && res.ok) {
            controller.refresh({ openOnUpdate: flags.add });
          }
          return res;
        });
      };
      wrapped.__mantoCartWrapped = true;
      window.fetch = wrapped;
    }

    // Wrap XHR (fallback)
    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__mantoCartWrapped) {
      const XHR = window.XMLHttpRequest;
      const originalOpen = XHR.prototype.open;
      const originalSend = XHR.prototype.send;

      XHR.prototype.open = function(method, url) {
        this.__mantoCartUrl = url;
        return originalOpen.apply(this, arguments);
      };

      XHR.prototype.send = function(body) {
        const url = this.__mantoCartUrl || "";
        const flags = getCartFlags(url);

        if (flags.any) {
          this.addEventListener("loadend", () => {
            try {
              if (this.status >= 200 && this.status < 300) {
                controller.refresh({ openOnUpdate: flags.add });
              }
            } catch (e) {
              // noop
            }
          });
        }

        return originalSend.apply(this, arguments);
      };

      XHR.prototype.__mantoCartWrapped = true;
    }
  }


  /**
   * Força formulários de /cart/add a usarem AJAX para manter
   * o Drawer em tempo real (PDP e qualquer outro template).
   */
  function hijackAddToCartForms(controller) {
    if (!controller || !controller.drawer) return;

    // Handler único em captura para pegar antes do tema
    window.addEventListener(
      "submit",
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        var action = (form.getAttribute("action") || "").split("?")[0];
        if (!/\/cart\/add(\.js)?$/.test(action)) return;

        event.preventDefault();
        event.stopPropagation();

        try {
          var formData = new FormData(form);

          // Garante que aceitamos JSON para evitar redirects
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json"
            },
            body: formData
          })
            .then(function () {
              controller.refresh({ openOnUpdate: true });
            })
            .catch(function () {
              controller.refresh({ openOnUpdate: true });
            });
        } catch (e) {
          console.error("[MANTO][cart] Erro ao interceptar /cart/add", e);
          controller.refresh({ openOnUpdate: true });
        }
      },
      true
    );
  }

  const instance = new MantoCartDrawerController();
  if (instance && instance.drawer) {
    window.MantoCartDrawer = instance;
    if (!window.CartDrawer) {
      window.CartDrawer = instance;
    }
    hookCartNetwork(instance);
    hijackAddToCartForms(instance);
  }
})();
